import { useContext, useState } from 'react'
import styled from 'styled-components'
import parse from 'html-react-parser'
import { t } from 'ttag'

import { Globals } from '@h2/globals'
import { TextToSpeech } from '@h2/common/components/textToSpeech'
import { replaceVariables } from '@main/actions/planning/assignments'
import { ProgressBar } from '@h2/components/display/progressBar'
import { SLB, SLB90T, WHITE } from '@h2/components/colors'
import { MuseoHeading, MuseoText } from '@h2/features/planning/earlyStyles'

// See solution https://stackoverflow.com/a/55554595. Solves error: `Cannot create styled-component for component: undefined`
const Description = styled(props => <MuseoText {...props} />)`
  > div > div {
    background-color: ${SLB90T};
  }
  p {
    margin-bottom: none;
  }
  p:nth-of-type(1),
  p:nth-of-type(2) {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  p:not(:first-of-type):not(:nth-of-type(2)) {
    display: none;
  }

  img {
    max-width: 100%;
  }
`
const LessonInfo = ({ lessonToDisplay, renderStyleForNewLesson }) => {
  // Text Reader
  const { userProfile } = useContext(Globals)
  const [language] = useState(userProfile.languageId?.replace('_', '-') || 'en-US')
  const guessPersona = requestedLanguage => {
    const persona = requestedLanguage?.startsWith('es') ? 'Lupe' : 'Joanna'

    return persona
  }
  const [readerPersonaName] = useState(guessPersona(language))
  const renderText = input => {
    return (
      <Description size="large" fontSize="30px">
        <TextToSpeech
          align="horizontal"
          markTextAsSpoken
          gender="Female"
          name={readerPersonaName}
          locale={language}
          highlightBgColor={SLB}
          position="topRight">
          {input}
        </TextToSpeech>
      </Description>
    )
  }

  return (
    <>
      {renderStyleForNewLesson ? (
        <>
          <MuseoHeading level="1">{lessonToDisplay.name}</MuseoHeading>
          {lessonToDisplay.description &&
            renderText(parse(replaceVariables(lessonToDisplay.description || '')))}
        </>
      ) : (
        <>
          <MuseoHeading level="1">{lessonToDisplay.name}</MuseoHeading>
          <MuseoHeading level="4">{t`Lesson Progress`}</MuseoHeading>
          <ProgressBar
            value={lessonToDisplay.percentComplete}
            size="large"
            display="green"
            bgColor={WHITE}
          />
        </>
      )}
    </>
  )
}

export { LessonInfo }
